var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilitiModeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16.5079C32 25.625 24.6154 34.2857 16 40C6.76923 33.6508 0 25.625 0 16.5079C0 7.39086 7.16344 0 16 0C24.8366 0 32 7.39086 32 16.5079Z",
    fill: "#408E8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.2416L11.9524 30L14.8095 19.1318H11C11.9524 16.9266 14.0476 12.1383 14.8095 10.6262C16.7143 9.49211 19.0952 10.1537 20.0476 10.6262L16.7143 17.2416H21Z",
    fill: "#FFC20E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilitiModeOn);
export default __webpack_public_path__ + "static/media/mobiliti_mode_on.6f50a6f03e980f620ca5425e139778f3.svg";
export { ForwardRef as ReactComponent };